import React from "react";
import { observer } from "mobx-react-lite";
import Select from "react-select";

const CodeParamsTypeSelect = observer(({ store, isDisabled = false }) => {
  return (<>
      <Select
        className="react-select-container"
        classNamePrefix="react-select"
        options={store?.options()}
        //defaultValue={store?.selectedCodeParameters ? store?.selectedCodeParameters : []}
        value={store?.selectedCodeParameters.map((param) => ({label: param.label, uuid: param.uuid}))}
        getOptionLabel={option => option.label}
        getOptionValue={option => option.uuid}
        onChange={(data) => store?.selectParameters(data)}
        placeholder="Select"
        isMulti
        isDisabled={isDisabled}
      />
    </>
  );
});

export default CodeParamsTypeSelect;
